module.exports = __webpack_public_path__ + "img/PP_Sword_1039.b9828632.png";